// #/services/registry/listServiceKeys.ts

import identity from 'lodash/identity';
import orderBy from 'lodash/orderBy';

import { PATH_SERVICES } from '#/services/s3/filepaths';
import listObjects from '#/services/s3/actions/listObjects';

function removeJsonFileExtension(s: string) {
  return s.replace(/\.json$/, '');
}

export async function listServiceKeys(): Promise<string[]> {
  try {
    const folderKey = PATH_SERVICES;

    const services: string[] = await listObjects({ folderKey });

    const serviceKeys: string[] = [
      ...orderBy(
        services
          .filter((s) => s !== '.file_placeholder')
          .map((s) => removeJsonFileExtension(s)),
        identity,
        'asc',
      ),
    ]
      .map((k) => k.split('/').slice(-1)[0])
      .filter((k) => k !== '.file_placeholder');

    console.debug(serviceKeys);

    return serviceKeys;
  } catch (error: any) {
    console.error(`Error fetching list of OpenAPI services: ${error.message}`);
    // throw new Error(`Error fetching list of OpenAPI services: ${error.message}`);
    return [];
  }
}

export default listServiceKeys;
